import { useCallback, useEffect, useState } from "react";
import {
  getPatientDirectorySnapshot,
  loadPatientDirectory,
  subscribeToPatientDirectory,
} from "../utils/patientDirectoryService";

export function usePatientDirectory(userId) {
  const [state, setState] = useState(() => ({
    userId,
    value: getPatientDirectorySnapshot(userId),
  }));
  const visibleState = state.userId === userId
    ? state.value
    : getPatientDirectorySnapshot(userId);

  useEffect(() => {
    setState({ userId, value: getPatientDirectorySnapshot(userId) });
    if (!userId) return undefined;
    const unsubscribe = subscribeToPatientDirectory(userId, (value) => {
      setState({ userId, value });
    });
    loadPatientDirectory(userId).catch(() => {});
    return unsubscribe;
  }, [userId]);

  const refresh = useCallback(
    () => loadPatientDirectory(userId, { force: true }),
    [userId]
  );

  return {
    ...visibleState,
    isLoading: visibleState.isLoading && !visibleState.hasLoaded,
    isRefreshing: visibleState.isLoading && visibleState.hasLoaded,
    refresh,
  };
}
